import { PatchQueueRequestPriority } from 'domain/usecases';
import { BaseHttpService } from 'main/factories/http';

export class RemotePatchPriorityAskRequest
  extends BaseHttpService<PatchQueueRequestPriority.Model>
  implements PatchQueueRequestPriority
{
  async patch({ priority }: { priority: 'Blocker' | 'Normal' }): Promise<PatchQueueRequestPriority.Model> {
    return await this.request('patch', { priority });
  }
}
